import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { Salutation, User } from '../../@types/user'
import { fetchUserInfo } from './thunks'

export const initialUserState: User = {
  dataProtectionAccepted: false,
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  salutation: Salutation.HERR,
  hasNotSeenContactForm: true,
}

const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    updateSalutation: (state, action: PayloadAction<Salutation>) => {
      state.salutation = action.payload
    },
    updateFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload
    },
    updateLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload
    },
    updateEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    updateDataProtectionAccepted: (state, action: PayloadAction<boolean>) => {
      state.dataProtectionAccepted = action.payload
    },
    updatePhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload
    },
    updateHasNotSeenContactForm: (state, action: PayloadAction<boolean>) => {
      state.hasNotSeenContactForm = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserInfo.fulfilled, (state, { payload }) => {
      return { ...state, ...payload }
    })
  },
})

export const {
  updateSalutation,
  updateFirstName,
  updateLastName,
  updateEmail,
  updatePhoneNumber,
  updateDataProtectionAccepted,
  updateHasNotSeenContactForm,
} = userSlice.actions

export default userSlice.reducer
